"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UTM = void 0;
const grid_js_1 = require("@ngageoint/grid-js");
const sprintf = __importStar(require("sprintf-js"));
const decimal_format_1 = __importDefault(require("decimal-format"));
const GridZones_1 = require("../gzd/GridZones");
const MGRS_1 = require("../MGRS");
/**
 * Universal Transverse Mercator Projection
 */
class UTM {
    /**
     * Constructor
     *
     * @param zone
     *            zone number
     * @param hemisphere
     *            hemisphere
     * @param easting
     *            easting
     * @param northing
     *            northing
     */
    constructor(zone, hemisphere, easting, northing) {
        this.zone = zone;
        this.hemisphere = hemisphere;
        this.easting = easting;
        this.northing = northing;
    }
    /**
     * Create
     *
     * @param zone
     *            zone number
     * @param hemisphere
     *            hemisphere
     * @param easting
     *            easting
     * @param northing
     *            northing
     * @return UTM
     */
    static create(zone, hemisphere, easting, northing) {
        return new UTM(zone, hemisphere, easting, northing);
    }
    /**
     * Create a point from the UTM attributes
     *
     * @param zone
     *            zone number
     * @param hemisphere
     *            hemisphere
     * @param easting
     *            easting
     * @param northing
     *            northing
     * @return point
     */
    static point(zone, hemisphere, easting, northing) {
        return UTM.create(zone, hemisphere, easting, northing).toPoint();
    }
    /**
     * Get the zone number
     *
     * @return zone number
     */
    getZone() {
        return this.zone;
    }
    /**
     * Get the hemisphere
     *
     * @return hemisphere
     */
    getHemisphere() {
        return this.hemisphere;
    }
    /**
     * Get the easting
     *
     * @return easting
     */
    getEasting() {
        return this.easting;
    }
    /**
     * Get the northing
     *
     * @return northing
     */
    getNorthing() {
        return this.northing;
    }
    /**
     * Convert to a point
     *
     * @return point
     */
    toPoint() {
        let north = this.northing;
        if (this.hemisphere === grid_js_1.Hemisphere.SOUTH) {
            // Remove 10,000,000 meter offset used for southern hemisphere
            north -= 10000000.0;
        }
        // @formatter:off
        let latitude = ((north / 6366197.724 / 0.9996 +
            (1 +
                0.006739496742 * Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2) -
                (0.006739496742 *
                    Math.sin(north / 6366197.724 / 0.9996) *
                    Math.cos(north / 6366197.724 / 0.9996) *
                    (Math.atan(Math.cos(Math.atan((Math.exp(((this.easting - 500000) /
                        ((0.9996 * 6399593.625) /
                            Math.sqrt(1 + 0.006739496742 * Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2)))) *
                        (1 -
                            (((0.006739496742 *
                                Math.pow((this.easting - 500000) /
                                    ((0.9996 * 6399593.625) /
                                        Math.sqrt(1 + 0.006739496742 * Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2))), 2)) /
                                2) *
                                Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2)) /
                                3)) -
                        Math.exp((-(this.easting - 500000) /
                            ((0.9996 * 6399593.625) /
                                Math.sqrt(1 + 0.006739496742 * Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2)))) *
                            (1 -
                                (((0.006739496742 *
                                    Math.pow((this.easting - 500000) /
                                        ((0.9996 * 6399593.625) /
                                            Math.sqrt(1 + 0.006739496742 * Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2))), 2)) /
                                    2) *
                                    Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2)) /
                                    3))) /
                        2 /
                        Math.cos(((north -
                            0.9996 *
                                6399593.625 *
                                (north / 6366197.724 / 0.9996 -
                                    ((0.006739496742 * 3) / 4) *
                                        (north / 6366197.724 / 0.9996 + Math.sin((2 * north) / 6366197.724 / 0.9996) / 2) +
                                    (((Math.pow((0.006739496742 * 3) / 4, 2) * 5) / 3) *
                                        (3 * (north / 6366197.724 / 0.9996 + Math.sin((2 * north) / 6366197.724 / 0.9996) / 2) +
                                            Math.sin((2 * north) / 6366197.724 / 0.9996) *
                                                Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2))) /
                                        4 -
                                    (((Math.pow((0.006739496742 * 3) / 4, 3) * 35) / 27) *
                                        ((5 *
                                            (3 * (north / 6366197.724 / 0.9996 + Math.sin((2 * north) / 6366197.724 / 0.9996) / 2) +
                                                Math.sin((2 * north) / 6366197.724 / 0.9996) *
                                                    Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2))) /
                                            4 +
                                            Math.sin((2 * north) / 6366197.724 / 0.9996) *
                                                Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2) *
                                                Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2))) /
                                        3)) /
                            ((0.9996 * 6399593.625) /
                                Math.sqrt(1 + 0.006739496742 * Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2)))) *
                            (1 -
                                ((0.006739496742 *
                                    Math.pow((this.easting - 500000) /
                                        ((0.9996 * 6399593.625) /
                                            Math.sqrt(1 + 0.006739496742 * Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2))), 2)) /
                                    2) *
                                    Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2)) +
                            north / 6366197.724 / 0.9996))) *
                        Math.tan(((north -
                            0.9996 *
                                6399593.625 *
                                (north / 6366197.724 / 0.9996 -
                                    ((0.006739496742 * 3) / 4) *
                                        (north / 6366197.724 / 0.9996 + Math.sin((2 * north) / 6366197.724 / 0.9996) / 2) +
                                    (((Math.pow((0.006739496742 * 3) / 4, 2) * 5) / 3) *
                                        (3 * (north / 6366197.724 / 0.9996 + Math.sin((2 * north) / 6366197.724 / 0.9996) / 2) +
                                            Math.sin((2 * north) / 6366197.724 / 0.9996) *
                                                Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2))) /
                                        4 -
                                    (((Math.pow((0.006739496742 * 3) / 4, 3) * 35) / 27) *
                                        ((5 *
                                            (3 * (north / 6366197.724 / 0.9996 + Math.sin((2 * north) / 6366197.724 / 0.9996) / 2) +
                                                Math.sin((2 * north) / 6366197.724 / 0.9996) *
                                                    Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2))) /
                                            4 +
                                            Math.sin((2 * north) / 6366197.724 / 0.9996) *
                                                Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2) *
                                                Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2))) /
                                        3)) /
                            ((0.9996 * 6399593.625) /
                                Math.sqrt(1 + 0.006739496742 * Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2)))) *
                            (1 -
                                ((0.006739496742 *
                                    Math.pow((this.easting - 500000) /
                                        ((0.9996 * 6399593.625) /
                                            Math.sqrt(1 + 0.006739496742 * Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2))), 2)) /
                                    2) *
                                    Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2)) +
                            north / 6366197.724 / 0.9996)) -
                        north / 6366197.724 / 0.9996) *
                    3) /
                    2) *
                (Math.atan(Math.cos(Math.atan((Math.exp(((this.easting - 500000) /
                    ((0.9996 * 6399593.625) /
                        Math.sqrt(1 + 0.006739496742 * Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2)))) *
                    (1 -
                        (((0.006739496742 *
                            Math.pow((this.easting - 500000) /
                                ((0.9996 * 6399593.625) /
                                    Math.sqrt(1 + 0.006739496742 * Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2))), 2)) /
                            2) *
                            Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2)) /
                            3)) -
                    Math.exp((-(this.easting - 500000) /
                        ((0.9996 * 6399593.625) /
                            Math.sqrt(1 + 0.006739496742 * Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2)))) *
                        (1 -
                            (((0.006739496742 *
                                Math.pow((this.easting - 500000) /
                                    ((0.9996 * 6399593.625) /
                                        Math.sqrt(1 + 0.006739496742 * Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2))), 2)) /
                                2) *
                                Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2)) /
                                3))) /
                    2 /
                    Math.cos(((north -
                        0.9996 *
                            6399593.625 *
                            (north / 6366197.724 / 0.9996 -
                                ((0.006739496742 * 3) / 4) *
                                    (north / 6366197.724 / 0.9996 + Math.sin((2 * north) / 6366197.724 / 0.9996) / 2) +
                                (((Math.pow((0.006739496742 * 3) / 4, 2) * 5) / 3) *
                                    (3 * (north / 6366197.724 / 0.9996 + Math.sin((2 * north) / 6366197.724 / 0.9996) / 2) +
                                        Math.sin((2 * north) / 6366197.724 / 0.9996) *
                                            Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2))) /
                                    4 -
                                (((Math.pow((0.006739496742 * 3) / 4, 3) * 35) / 27) *
                                    ((5 *
                                        (3 * (north / 6366197.724 / 0.9996 + Math.sin((2 * north) / 6366197.724 / 0.9996) / 2) +
                                            Math.sin((2 * north) / 6366197.724 / 0.9996) *
                                                Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2))) /
                                        4 +
                                        Math.sin((2 * north) / 6366197.724 / 0.9996) *
                                            Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2) *
                                            Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2))) /
                                    3)) /
                        ((0.9996 * 6399593.625) /
                            Math.sqrt(1 + 0.006739496742 * Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2)))) *
                        (1 -
                            ((0.006739496742 *
                                Math.pow((this.easting - 500000) /
                                    ((0.9996 * 6399593.625) /
                                        Math.sqrt(1 + 0.006739496742 * Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2))), 2)) /
                                2) *
                                Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2)) +
                        north / 6366197.724 / 0.9996))) *
                    Math.tan(((north -
                        0.9996 *
                            6399593.625 *
                            (north / 6366197.724 / 0.9996 -
                                ((0.006739496742 * 3) / 4) *
                                    (north / 6366197.724 / 0.9996 + Math.sin((2 * north) / 6366197.724 / 0.9996) / 2) +
                                (((Math.pow((0.006739496742 * 3) / 4, 2) * 5) / 3) *
                                    (3 * (north / 6366197.724 / 0.9996 + Math.sin((2 * north) / 6366197.724 / 0.9996) / 2) +
                                        Math.sin((2 * north) / 6366197.724 / 0.9996) *
                                            Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2))) /
                                    4 -
                                (((Math.pow((0.006739496742 * 3) / 4, 3) * 35) / 27) *
                                    ((5 *
                                        (3 * (north / 6366197.724 / 0.9996 + Math.sin((2 * north) / 6366197.724 / 0.9996) / 2) +
                                            Math.sin((2 * north) / 6366197.724 / 0.9996) *
                                                Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2))) /
                                        4 +
                                        Math.sin((2 * north) / 6366197.724 / 0.9996) *
                                            Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2) *
                                            Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2))) /
                                    3)) /
                        ((0.9996 * 6399593.625) /
                            Math.sqrt(1 + 0.006739496742 * Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2)))) *
                        (1 -
                            ((0.006739496742 *
                                Math.pow((this.easting - 500000) /
                                    ((0.9996 * 6399593.625) /
                                        Math.sqrt(1 + 0.006739496742 * Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2))), 2)) /
                                2) *
                                Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2)) +
                        north / 6366197.724 / 0.9996)) -
                    north / 6366197.724 / 0.9996)) *
            180) /
            Math.PI;
        // @formatter:on
        latitude = Math.round(latitude * 10000000);
        latitude = latitude / 10000000;
        // @formatter:off
        let longitude = (Math.atan((Math.exp(((this.easting - 500000) /
            ((0.9996 * 6399593.625) /
                Math.sqrt(1 + 0.006739496742 * Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2)))) *
            (1 -
                (((0.006739496742 *
                    Math.pow((this.easting - 500000) /
                        ((0.9996 * 6399593.625) /
                            Math.sqrt(1 + 0.006739496742 * Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2))), 2)) /
                    2) *
                    Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2)) /
                    3)) -
            Math.exp((-(this.easting - 500000) /
                ((0.9996 * 6399593.625) /
                    Math.sqrt(1 + 0.006739496742 * Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2)))) *
                (1 -
                    (((0.006739496742 *
                        Math.pow((this.easting - 500000) /
                            ((0.9996 * 6399593.625) /
                                Math.sqrt(1 + 0.006739496742 * Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2))), 2)) /
                        2) *
                        Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2)) /
                        3))) /
            2 /
            Math.cos(((north -
                0.9996 *
                    6399593.625 *
                    (north / 6366197.724 / 0.9996 -
                        ((0.006739496742 * 3) / 4) *
                            (north / 6366197.724 / 0.9996 + Math.sin((2 * north) / 6366197.724 / 0.9996) / 2) +
                        (((Math.pow((0.006739496742 * 3) / 4, 2) * 5) / 3) *
                            (3 * (north / 6366197.724 / 0.9996 + Math.sin((2 * north) / 6366197.724 / 0.9996) / 2) +
                                Math.sin((2 * north) / 6366197.724 / 0.9996) *
                                    Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2))) /
                            4 -
                        (((Math.pow((0.006739496742 * 3) / 4, 3) * 35) / 27) *
                            ((5 *
                                (3 * (north / 6366197.724 / 0.9996 + Math.sin((2 * north) / 6366197.724 / 0.9996) / 2) +
                                    Math.sin((2 * north) / 6366197.724 / 0.9996) *
                                        Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2))) /
                                4 +
                                Math.sin((2 * north) / 6366197.724 / 0.9996) *
                                    Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2) *
                                    Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2))) /
                            3)) /
                ((0.9996 * 6399593.625) /
                    Math.sqrt(1 + 0.006739496742 * Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2)))) *
                (1 -
                    ((0.006739496742 *
                        Math.pow((this.easting - 500000) /
                            ((0.9996 * 6399593.625) /
                                Math.sqrt(1 + 0.006739496742 * Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2))), 2)) /
                        2) *
                        Math.pow(Math.cos(north / 6366197.724 / 0.9996), 2)) +
                north / 6366197.724 / 0.9996)) *
            180) /
            Math.PI +
            this.zone * 6 -
            183;
        // @formatter:on
        longitude = Math.round(longitude * 10000000);
        longitude = longitude / 10000000;
        return grid_js_1.Point.degrees(longitude, latitude);
    }
    /**
     * Convert to a MGRS coordinate
     *
     * @return MGRS
     */
    toMGRS() {
        return MGRS_1.MGRS.from(this.toPoint());
    }
    /**
     * Format to a UTM string
     *
     * @return UTM string
     */
    format() {
        let value = '';
        const formatter = new decimal_format_1.default('0.##');
        value += sprintf.sprintf('%02d', this.zone);
        value += ' ';
        value += this.hemisphere === grid_js_1.Hemisphere.NORTH ? grid_js_1.GridConstants.NORTH_CHAR : grid_js_1.GridConstants.SOUTH_CHAR;
        value += ' ';
        value += formatter.format(this.easting);
        value += ' ';
        value += formatter.format(this.northing);
        return value.toString();
    }
    /**
     * {@inheritDoc}
     */
    toString() {
        return this.format();
    }
    /**
     * Return whether the given string is valid UTM string
     *
     * @param utm
     *            potential UTM string
     * @return true if UTM string is valid, false otherwise
     */
    static isUTM(utm) {
        return this.utmPattern.test(utm);
    }
    /**
     * Parse a UTM value (Zone N|S Easting Northing)
     *
     * @param utm
     *            UTM value
     * @return UTM
     * @throws ParseException
     *             upon failure to parse UTM value
     */
    static parse(utm) {
        if (!this.utmPattern.test(utm)) {
            throw new Error('Invalid UTM: ' + utm);
        }
        const matches = utm.match(this.utmPattern);
        const zone = Number.parseInt(matches[1], 10);
        const hemisphere = matches[2].localeCompare(grid_js_1.GridConstants.NORTH_CHAR, undefined, { sensitivity: 'base' }) === 0
            ? grid_js_1.Hemisphere.NORTH
            : grid_js_1.Hemisphere.SOUTH;
        const easting = +matches[3];
        const northing = +matches[4];
        return UTM.create(zone, hemisphere, easting, northing);
    }
    /**
     * Create from a coordinate, zone number, and hemisphere
     *
     * @param point
     *            coordinate
     * @param zone
     *            zone number
     * @param hemisphere
     *            hemisphere
     * @return UTM
     */
    static from(point, zone, hemisphere) {
        if (!zone) {
            zone = GridZones_1.GridZones.getZoneNumberFromPoint(point);
        }
        if (!hemisphere) {
            hemisphere = grid_js_1.HemisphereUtils.from(point);
        }
        point = point.toDegrees();
        const latitude = point.getLatitude();
        const longitude = point.getLongitude();
        // @formatter:off
        let easting = ((0.5 *
            Math.log((1 +
                Math.cos((latitude * Math.PI) / 180) *
                    Math.sin((longitude * Math.PI) / 180 - ((6 * zone - 183) * Math.PI) / 180)) /
                (1 -
                    Math.cos((latitude * Math.PI) / 180) *
                        Math.sin((longitude * Math.PI) / 180 - ((6 * zone - 183) * Math.PI) / 180))) *
            0.9996 *
            6399593.62) /
            Math.pow(1 + Math.pow(0.0820944379, 2) * Math.pow(Math.cos((latitude * Math.PI) / 180), 2), 0.5)) *
            (1 +
                ((Math.pow(0.0820944379, 2) / 2) *
                    Math.pow(0.5 *
                        Math.log((1 +
                            Math.cos((latitude * Math.PI) / 180) *
                                Math.sin((longitude * Math.PI) / 180 - ((6 * zone - 183) * Math.PI) / 180)) /
                            (1 -
                                Math.cos((latitude * Math.PI) / 180) *
                                    Math.sin((longitude * Math.PI) / 180 - ((6 * zone - 183) * Math.PI) / 180))), 2) *
                    Math.pow(Math.cos((latitude * Math.PI) / 180), 2)) /
                    3) +
            500000;
        // @formatter:on
        easting = Math.round(easting * 100) * 0.01;
        // @formatter:off
        let northing = (((Math.atan(Math.tan((latitude * Math.PI) / 180) /
            Math.cos((longitude * Math.PI) / 180 - ((6 * zone - 183) * Math.PI) / 180)) -
            (latitude * Math.PI) / 180) *
            0.9996 *
            6399593.625) /
            Math.sqrt(1 + 0.006739496742 * Math.pow(Math.cos((latitude * Math.PI) / 180), 2))) *
            (1 +
                (0.006739496742 / 2) *
                    Math.pow(0.5 *
                        Math.log((1 +
                            Math.cos((latitude * Math.PI) / 180) *
                                Math.sin((longitude * Math.PI) / 180 - ((6 * zone - 183) * Math.PI) / 180)) /
                            (1 -
                                Math.cos((latitude * Math.PI) / 180) *
                                    Math.sin((longitude * Math.PI) / 180 - ((6 * zone - 183) * Math.PI) / 180))), 2) *
                    Math.pow(Math.cos((latitude * Math.PI) / 180), 2)) +
            0.9996 *
                6399593.625 *
                ((latitude * Math.PI) / 180 -
                    0.005054622556 * ((latitude * Math.PI) / 180 + Math.sin((2 * latitude * Math.PI) / 180) / 2) +
                    (4.258201531e-5 *
                        (3 * ((latitude * Math.PI) / 180 + Math.sin((2 * latitude * Math.PI) / 180) / 2) +
                            Math.sin((2 * latitude * Math.PI) / 180) * Math.pow(Math.cos((latitude * Math.PI) / 180), 2))) /
                        4 -
                    (1.674057895e-7 *
                        ((5 *
                            (3 * ((latitude * Math.PI) / 180 + Math.sin((2 * latitude * Math.PI) / 180) / 2) +
                                Math.sin((2 * latitude * Math.PI) / 180) * Math.pow(Math.cos((latitude * Math.PI) / 180), 2))) /
                            4 +
                            Math.sin((2 * latitude * Math.PI) / 180) *
                                Math.pow(Math.cos((latitude * Math.PI) / 180), 2) *
                                Math.pow(Math.cos((latitude * Math.PI) / 180), 2))) /
                        3);
        // @formatter:on
        if (hemisphere === grid_js_1.Hemisphere.SOUTH) {
            northing = northing + 10000000;
        }
        northing = Math.round(northing * 100) * 0.01;
        return UTM.create(zone, hemisphere, easting, northing);
    }
}
exports.UTM = UTM;
/**
 * UTM string pattern
 */
UTM.utmPattern = new RegExp('^(\\d{1,2})\\s*([N|S])\\s*(\\d+\\.?\\d*)\\s*(\\d+\\.?\\d*)$', 'i');
//# sourceMappingURL=UTM.js.map